module.exports = __webpack_public_path__ + "static/img/score-pc-1.5f64451d.png";